import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { PaymentOption } from '../paymentOption';

export interface PaymentChoiceListModel extends BaseFieldModel {
  defaultValue: string[] | undefined;
  choices: PaymentOption[];
  type: FieldType.PaymentChoiceList;
}
export class PaymentChoiceList extends BaseField implements PaymentChoiceListModel {
  public defaultValue: string[] | undefined;
  public choices: PaymentOption[] = [];
  public type: FieldType.PaymentChoiceList = FieldType.PaymentChoiceList;

  constructor(cultures: string[]) {
    super(FieldType.PaymentChoiceList, cultures);
  }
}
